/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetPairingStatusResponse } from '../models/GetPairingStatusResponse';
import type { PairingAttestationVerifyRequest } from '../models/PairingAttestationVerifyRequest';
import type { PairingAttestationVerifyResponse } from '../models/PairingAttestationVerifyResponse';
import type { PairingRegisterRequest } from '../models/PairingRegisterRequest';
import type { PairingValidateRequest } from '../models/PairingValidateRequest';
import type { PairingValidateResponse } from '../models/PairingValidateResponse';
import type { RegisterDeviceRequest } from '../models/RegisterDeviceRequest';
import type { RegisterDeviceResponse } from '../models/RegisterDeviceResponse';
import type { StartPairingResponse } from '../models/StartPairingResponse';
import type { ValidatePairingCodeRequest } from '../models/ValidatePairingCodeRequest';
import type { ValidatePairingCodeResponse } from '../models/ValidatePairingCodeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DevicePairingService {
    /**
     * Register a device using a pairing code
     * Register a device using a pairing code.
     *
     * This is a public unauthenticated endpoint that allows a device to register
     * itself using a valid pairing code obtained from an authenticated session.
     * @param requestBody
     * @returns RegisterDeviceResponse Successful Response
     * @throws ApiError
     */
    public static registerDevice(
        requestBody: RegisterDeviceRequest,
    ): CancelablePromise<RegisterDeviceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/device/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Validate a pairing code and assign device
     * Validate pairing code and assign device_id.
     *
     * This is a public unauthenticated endpoint that allows a device to:
     * 1. Verify a pairing code is valid and pending
     * 2. Claim the session by setting its device_id
     * @param pairingCode
     * @param requestBody
     * @returns ValidatePairingCodeResponse Successful Response
     * @throws ApiError
     */
    public static validatePairingCode(
        pairingCode: string,
        requestBody: ValidatePairingCodeRequest,
    ): CancelablePromise<ValidatePairingCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/device/validate/{pairing_code}',
            path: {
                'pairing_code': pairingCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Validate a pairing code and issue an attestation challenge
     * Validate the QR pairing code; on success mint a single-use verification token the client binds its attestation to.
     * @param requestBody
     * @returns PairingValidateResponse Successful Response
     * @throws ApiError
     */
    public static validatePairing(
        requestBody: PairingValidateRequest,
    ): CancelablePromise<PairingValidateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/device/attestation/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify a pairing device attestation
     * Verify the attestation token against the issued verification token. On pass, returns a pairing token required to complete registration.
     * @param requestBody
     * @returns PairingAttestationVerifyResponse Successful Response
     * @throws ApiError
     */
    public static verifyPairingAttestation(
        requestBody: PairingAttestationVerifyRequest,
    ): CancelablePromise<PairingAttestationVerifyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/device/attestation/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Complete pairing for an attested device
     * Register the device and complete pairing, gated on a passing attestation (the pairing token issued by /verify).
     * @param requestBody
     * @returns RegisterDeviceResponse Successful Response
     * @throws ApiError
     */
    public static registerAttestedDevice(
        requestBody: PairingRegisterRequest,
    ): CancelablePromise<RegisterDeviceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/device/attestation/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Device Pairing
     * Start a device pairing flow to add a new device (requires escalation)
     * @param userSession
     * @returns StartPairingResponse Successful Response
     * @throws ApiError
     */
    public static startDevicePairing(
        userSession?: (string | null),
    ): CancelablePromise<StartPairingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment/device/start-pair',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Device Pairing Status
     * Get the status of a device pairing session (requires valid session)
     * @param pairingCode
     * @param userSession
     * @returns GetPairingStatusResponse Successful Response
     * @throws ApiError
     */
    public static getPairingStatus(
        pairingCode: string,
        userSession?: (string | null),
    ): CancelablePromise<GetPairingStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/enrollment/device/status/{pairing_code}',
            path: {
                'pairing_code': pairingCode,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
